/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

class ResetNode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      node: props.node,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node.reset');
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps({ showModal, node }) {
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (!_.isEqual(node, this.props.node)) {
      this.setState({ node });
    }
  }

  onSubmit() {
    this.setState({ submitStatus: 'pending' });

    const { node: { id } } = this.state;
    callAPI({
      endpoint: `/tdmng/nodes/${id}/ctrl/kick`,
      method: 'POST',
    }).then(() => {
      this.setState({ submitStatus: 'success' });

      _.delay(() => {
        this.props.onCancel();
      }, 250);
    }).catch(() => {
      this.setState({ submitStatus: 'failure' });
    });
  }

  render() {
    const { showModal, submitStatus } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-warning"
        show={showModal}
        backdrop="static"
        onHide={this.props.onCancel}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('single.title')}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {this.intlMsg.msg('single.warn')}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="aisz-default"
            onClick={this.props.onCancel}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-warning"
            onClick={this.onSubmit}
            disabled={submitStatus === 'pending'}
          >
            {submitStatus === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ResetNode.propTypes = propTypes;

export default injectIntl(ResetNode);





// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Node/ResetNode.jsx